/* unplugin-vue-components disabled */import _toConsumableArray from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/svg/nav-theme-dark.svg';
import _imports_1 from '@/assets/svg/nav-theme-light.svg';
import _imports_2 from '@/assets/svg/header-theme-dark.svg';
import _imports_3 from '@/assets/svg/header-theme-primary.svg';
var _hoisted_1 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_2 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_3 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_4 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_5 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_6 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_7 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_8 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_9 = {
  class: "i-layout-header-setting-item-desc"
};
var _hoisted_10 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_11 = {
  class: "i-layout-header-setting-item-desc"
};
var _hoisted_12 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_13 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_14 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_15 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_16 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_17 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_18 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_19 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_20 = {
  class: "i-layout-header-setting-item-desc"
};
var _hoisted_21 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_22 = {
  class: "i-layout-header-setting-item-desc"
};
var _hoisted_23 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_24 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_25 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_26 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_27 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_28 = {
  class: "i-layout-header-setting-item"
};
var _hoisted_29 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_30 = {
  class: "i-layout-header-setting-item-desc"
};
var _hoisted_31 = {
  class: "i-layout-header-setting-item-action"
};
var _hoisted_32 = {
  class: "i-layout-header-setting-item-desc"
};
var _hoisted_33 = {
  class: "i-layout-header-setting-item-action"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Icon = _resolveComponent("Icon");
  var _component_Divider = _resolveComponent("Divider");
  var _component_Tooltip = _resolveComponent("Tooltip");
  var _component_Switch = _resolveComponent("Switch");
  var _component_Alert = _resolveComponent("Alert");
  var _component_Drawer = _resolveComponent("Drawer");
  return _openBlock(), _createElementBlock("span", {
    class: "i-layout-header-trigger i-layout-header-trigger-min",
    onClick: _cache[21] || (_cache[21] = function () {
      return $options.showSetting && $options.showSetting.apply($options, arguments);
    })
  }, [_createVNode(_component_Icon, {
    type: "md-more"
  }), _createVNode(_component_Drawer, {
    modelValue: $data.visible,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
      return $data.visible = $event;
    }),
    width: "280"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_Divider, {
        size: "small"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[22] || (_cache[22] = [_createTextVNode("主题风格设置", -1 /* CACHED */)]));
        }),
        _: 1 /* STABLE */
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item-radio", {
          'on': _ctx.siderTheme === 'dark'
        }]),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $options.handleChangeSetting('siderTheme', 'dark');
        })
      }, [_createVNode(_component_Tooltip, {
        content: "暗色侧边栏",
        placement: "top",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[23] || (_cache[23] = [_createElementVNode("img", {
            src: _imports_0
          }, null, -1 /* CACHED */)]));
        }),
        _: 1 /* STABLE */
      })], 2 /* CLASS */), _createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item-radio", {
          'on': _ctx.siderTheme === 'light'
        }]),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $options.handleChangeSetting('siderTheme', 'light');
        })
      }, [_createVNode(_component_Tooltip, {
        content: "亮色侧边栏",
        placement: "top",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[24] || (_cache[24] = [_createElementVNode("img", {
            src: _imports_1
          }, null, -1 /* CACHED */)]));
        }),
        _: 1 /* STABLE */
      })], 2 /* CLASS */)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item-radio", {
          'on': _ctx.headerTheme === 'light'
        }]),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return $options.handleChangeSetting('headerTheme', 'light');
        })
      }, [_createVNode(_component_Tooltip, {
        content: "亮色顶栏",
        placement: "top",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[25] || (_cache[25] = [_createElementVNode("img", {
            src: _imports_0
          }, null, -1 /* CACHED */)]));
        }),
        _: 1 /* STABLE */
      })], 2 /* CLASS */), _createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item-radio", {
          'on': _ctx.headerTheme === 'dark'
        }]),
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return $options.handleChangeSetting('headerTheme', 'dark');
        })
      }, [_createVNode(_component_Tooltip, {
        content: "暗色顶栏",
        placement: "top",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[26] || (_cache[26] = [_createElementVNode("img", {
            src: _imports_2
          }, null, -1 /* CACHED */)]));
        }),
        _: 1 /* STABLE */
      })], 2 /* CLASS */), _createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item-radio", {
          'on': _ctx.headerTheme === 'primary'
        }]),
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return $options.handleChangeSetting('headerTheme', 'primary');
        })
      }, [_createVNode(_component_Tooltip, {
        content: "主色顶栏",
        placement: "top",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[27] || (_cache[27] = [_createElementVNode("img", {
            src: _imports_3
          }, null, -1 /* CACHED */)]));
        }),
        _: 1 /* STABLE */
      })], 2 /* CLASS */)]), _createVNode(_component_Divider, {
        size: "small"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[28] || (_cache[28] = [_createTextVNode("导航设置", -1 /* CACHED */)]));
        }),
        _: 1 /* STABLE */
      }), _createElementVNode("div", _hoisted_3, [_cache[29] || (_cache[29] = _createElementVNode("span", {
        class: "i-layout-header-setting-item-desc"
      }, "显示顶栏菜单", -1 /* CACHED */)), _createElementVNode("span", _hoisted_4, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.headerMenu,
        onOnChange: _cache[5] || (_cache[5] = function (val) {
          return $options.handleChangeSetting('headerMenu', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createElementVNode("div", _hoisted_5, [_cache[30] || (_cache[30] = _createElementVNode("span", {
        class: "i-layout-header-setting-item-desc"
      }, "固定侧边栏", -1 /* CACHED */)), _createElementVNode("span", _hoisted_6, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.siderFix,
        onOnChange: _cache[6] || (_cache[6] = function (val) {
          return $options.handleChangeSetting('siderFix', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createElementVNode("div", _hoisted_7, [_cache[31] || (_cache[31] = _createElementVNode("span", {
        class: "i-layout-header-setting-item-desc"
      }, "固定顶栏", -1 /* CACHED */)), _createElementVNode("span", _hoisted_8, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.headerFix,
        onOnChange: _cache[7] || (_cache[7] = function (val) {
          return $options.handleChangeSetting('headerFix', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item", {
          'i-layout-header-setting-item-disabled': !_ctx.headerFix
        }])
      }, [_createElementVNode("span", _hoisted_9, [_cache[32] || (_cache[32] = _createTextVNode(" 下滑时隐藏顶栏 ", -1 /* CACHED */)), _createVNode(_component_Tooltip, {
        placement: "top",
        content: "需开启固定顶栏",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Icon, {
            type: "ios-help-circle-outline"
          })];
        }),
        _: 1 /* STABLE */
      })]), _createElementVNode("span", _hoisted_10, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.headerHide,
        disabled: !_ctx.headerFix,
        onOnChange: _cache[8] || (_cache[8] = function (val) {
          return $options.handleChangeSetting('headerHide', val);
        })
      }, null, 8 /* PROPS */, ["model-value", "disabled"])])], 2 /* CLASS */), _createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item", {
          'i-layout-header-setting-item-disabled': !_ctx.headerFix
        }])
      }, [_createElementVNode("span", _hoisted_11, [_cache[33] || (_cache[33] = _createTextVNode(" 置顶顶栏 ", -1 /* CACHED */)), _createVNode(_component_Tooltip, {
        placement: "top",
        content: "需开启固定顶栏",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Icon, {
            type: "ios-help-circle-outline"
          })];
        }),
        _: 1 /* STABLE */
      })]), _createElementVNode("span", _hoisted_12, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.headerStick,
        disabled: !_ctx.headerFix,
        onOnChange: _cache[9] || (_cache[9] = function (val) {
          return $options.handleChangeSetting('headerStick', val);
        })
      }, null, 8 /* PROPS */, ["model-value", "disabled"])])], 2 /* CLASS */), _createElementVNode("div", _hoisted_13, [_cache[34] || (_cache[34] = _createElementVNode("span", {
        class: "i-layout-header-setting-item-desc"
      }, "侧边栏开启手风琴模式", -1 /* CACHED */)), _createElementVNode("span", _hoisted_14, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.menuAccordion,
        onOnChange: _cache[10] || (_cache[10] = function (val) {
          return $options.handleChangeSetting('menuAccordion', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createElementVNode("div", _hoisted_15, [_cache[35] || (_cache[35] = _createElementVNode("span", {
        class: "i-layout-header-setting-item-desc"
      }, "显示折叠侧边栏按钮", -1 /* CACHED */)), _createElementVNode("span", _hoisted_16, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.showSiderCollapse,
        onOnChange: _cache[11] || (_cache[11] = function (val) {
          return $options.handleChangeSetting('showSiderCollapse', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createElementVNode("div", _hoisted_17, [_cache[36] || (_cache[36] = _createElementVNode("span", {
        class: "i-layout-header-setting-item-desc"
      }, "侧边栏折叠时显示父级菜单名", -1 /* CACHED */)), _createElementVNode("span", _hoisted_18, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.showCollapseMenuTitle,
        onOnChange: _cache[12] || (_cache[12] = function (val) {
          return $options.handleChangeSetting('showCollapseMenuTitle', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, [_cache[37] || (_cache[37] = _createTextVNode(" 显示全局面包屑导航 ", -1 /* CACHED */)), _createVNode(_component_Tooltip, {
        placement: "top",
        content: "headerMenu 开启时无效",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Icon, {
            type: "ios-help-circle-outline"
          })];
        }),
        _: 1 /* STABLE */
      })]), _createElementVNode("span", _hoisted_21, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.showBreadcrumb,
        onOnChange: _cache[13] || (_cache[13] = function (val) {
          return $options.handleChangeSetting('showBreadcrumb', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item", {
          'i-layout-header-setting-item-disabled': !_ctx.showBreadcrumb
        }])
      }, [_createElementVNode("span", _hoisted_22, [_cache[38] || (_cache[38] = _createTextVNode(" 全局面包屑显示图标 ", -1 /* CACHED */)), _createVNode(_component_Tooltip, {
        placement: "top",
        content: "需开启全局面包屑导航",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Icon, {
            type: "ios-help-circle-outline"
          })];
        }),
        _: 1 /* STABLE */
      })]), _createElementVNode("span", _hoisted_23, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.showBreadcrumbIcon,
        disabled: !_ctx.showBreadcrumb,
        onOnChange: _cache[14] || (_cache[14] = function (val) {
          return $options.handleChangeSetting('showBreadcrumbIcon', val);
        })
      }, null, 8 /* PROPS */, ["model-value", "disabled"])])], 2 /* CLASS */), _createElementVNode("div", _hoisted_24, [_cache[39] || (_cache[39] = _createElementVNode("span", {
        class: "i-layout-header-setting-item-desc"
      }, "显示重载页面按钮", -1 /* CACHED */)), _createElementVNode("span", _hoisted_25, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.showReload,
        onOnChange: _cache[15] || (_cache[15] = function (val) {
          return $options.handleChangeSetting('showReload', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createElementVNode("div", _hoisted_26, [_cache[40] || (_cache[40] = _createElementVNode("span", {
        class: "i-layout-header-setting-item-desc"
      }, "显示多语言选择", -1 /* CACHED */)), _createElementVNode("span", _hoisted_27, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.showI18n,
        onOnChange: _cache[16] || (_cache[16] = function (val) {
          return $options.handleChangeSetting('showI18n', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createVNode(_component_Divider, {
        size: "small"
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[41] || (_cache[41] = [_createTextVNode("其它设置", -1 /* CACHED */)]));
        }),
        _: 1 /* STABLE */
      }), _createElementVNode("div", _hoisted_28, [_cache[42] || (_cache[42] = _createElementVNode("span", {
        class: "i-layout-header-setting-item-desc"
      }, "开启多页签", -1 /* CACHED */)), _createElementVNode("span", _hoisted_29, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.tabs,
        onOnChange: _cache[17] || (_cache[17] = function (val) {
          return $options.handleChangeSetting('tabs', val);
        })
      }, null, 8 /* PROPS */, ["model-value"])])]), _createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item", {
          'i-layout-header-setting-item-disabled': !_ctx.tabs
        }])
      }, [_createElementVNode("span", _hoisted_30, [_cache[43] || (_cache[43] = _createTextVNode(" 多页签显示图标 ", -1 /* CACHED */)), _createVNode(_component_Tooltip, {
        placement: "top",
        content: "需开启多页签",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Icon, {
            type: "ios-help-circle-outline"
          })];
        }),
        _: 1 /* STABLE */
      })]), _createElementVNode("span", _hoisted_31, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.showTabsIcon,
        disabled: !_ctx.tabs,
        onOnChange: _cache[18] || (_cache[18] = function (val) {
          return $options.handleChangeSetting('showTabsIcon', val);
        })
      }, null, 8 /* PROPS */, ["model-value", "disabled"])])], 2 /* CLASS */), _createElementVNode("div", {
        class: _normalizeClass(["i-layout-header-setting-item", {
          'i-layout-header-setting-item-disabled': !_ctx.tabs
        }])
      }, [_createElementVNode("span", _hoisted_32, [_cache[44] || (_cache[44] = _createTextVNode(" 固定多页签 ", -1 /* CACHED */)), _createVNode(_component_Tooltip, {
        placement: "top",
        content: "需开启多页签",
        transfer: ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_Icon, {
            type: "ios-help-circle-outline"
          })];
        }),
        _: 1 /* STABLE */
      })]), _createElementVNode("span", _hoisted_33, [_createVNode(_component_Switch, {
        size: "small",
        "model-value": _ctx.tabsFix,
        disabled: !_ctx.tabs,
        onOnChange: _cache[19] || (_cache[19] = function (val) {
          return $options.handleChangeSetting('tabsFix', val);
        })
      }, null, 8 /* PROPS */, ["model-value", "disabled"])])], 2 /* CLASS */), _createVNode(_component_Alert, {
        type: "warning"
      }, {
        desc: _withCtx(function () {
          return _toConsumableArray(_cache[45] || (_cache[45] = [_createElementVNode("div", null, [_createTextVNode(" 该功能主要实时预览各种布局效果，更多完整配置在 "), _createElementVNode("strong", null, "setting.js"), _createTextVNode(" 中设置。建议在生产环境关闭该布局预览功能。 ")], -1 /* CACHED */)]));
        }),
        _: 1 /* STABLE */
      })];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"])]);
}